/**
 * navigation.js — cùng vai trò với js/navigation.js của theme _s.
 *
 * Markup đầu vào chỉ cần đúng output của wp_nav_menu():
 *   ul.menu > li.menu-item.menu-item-has-children > a + ul.sub-menu
 * Nút caret (.dropdown-toggle) do script này chèn, PHP không phải sinh thêm gì.
 *
 * Desktop: sub-menu mở bằng CSS hover/focus-within (trễ 120ms), click caret vẫn bật tắt được.
 * Mobile:  .main-navigation là drawer, sub-menu chạy accordion.
 *
 * Viết theo cú pháp ES5 vì pipeline dùng uglify-js sau babel.
 */
(function () {
    'use strict';

    var DESKTOP_QUERY = '(min-width: 1024px)';

    var header = document.querySelector('.site-header');
    var nav = document.getElementById('site-navigation');
    var navToggle = document.querySelector('[data-nav-toggle]');
    var parents = nav ? [].slice.call(nav.querySelectorAll('.menu-item-has-children')) : [];

    function isDesktop() {
        return window.matchMedia(DESKTOP_QUERY).matches;
    }

    // ----- Sticky shadow + biến --header-height cho anchor / cột dính -----
    if (header) {
        var measureHeader = function () {
            document.documentElement.style.setProperty('--header-height', header.offsetHeight + 'px');
        };

        // Trên mobile, header thu gọn khi cuộn (ẩn topbar + ô tìm kiếm)
        // nên phải đo lại chiều cao mỗi lần đổi trạng thái.
        var stuck = null;
        var onScroll = function () {
            var next = window.pageYOffset > 24;
            if (next === stuck) return;
            stuck = next;
            header.classList.toggle('is-stuck', next);
            measureHeader();
        };

        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', measureHeader);
        window.addEventListener('load', measureHeader);
        onScroll();
        measureHeader();
    }

    // ----- Chèn nút caret cho item có sub-menu -----
    function setSubmenu(item, open) {
        item.classList.toggle('is-open', open);
        var button = item.querySelector('.dropdown-toggle');
        if (button) {
            button.setAttribute('aria-expanded', open ? 'true' : 'false');
        }
    }

    function closeSubmenus(except) {
        parents.forEach(function (item) {
            if (item !== except && !item.contains(except)) {
                setSubmenu(item, false);
            }
        });
    }

    // Flyout cấp 3 mở sang phải; nếu chạm mép màn hình thì lật sang trái.
    function positionFlyout(item) {
        if (!isDesktop()) return;
        var panel = item.querySelector(':scope > .sub-menu');
        if (!panel || !item.closest('.sub-menu')) return;

        item.classList.remove('is-flipped');
        if (panel.getBoundingClientRect().right > document.documentElement.clientWidth - 16) {
            item.classList.add('is-flipped');
        }
    }

    parents.forEach(function (item) {
        var link = item.querySelector(':scope > a');
        if (!link) return;

        item.addEventListener('mouseenter', function () {
            positionFlyout(item);
        });

        var button = document.createElement('button');
        button.className = 'dropdown-toggle';
        button.type = 'button';
        button.setAttribute('aria-expanded', 'false');
        button.setAttribute('aria-label', 'Open submenu of ' + link.textContent.trim());
        button.innerHTML = '<i class="ph ph-caret-down" aria-hidden="true"></i>';
        link.insertAdjacentElement('afterend', button);

        button.addEventListener('click', function (event) {
            event.preventDefault();
            event.stopPropagation();
            var willOpen = !item.classList.contains('is-open');
            closeSubmenus(item);
            if (willOpen) positionFlyout(item);
            setSubmenu(item, willOpen);
        });

        link.addEventListener('focus', function () {
            positionFlyout(item);
        });

        // Tab ra khỏi nhánh menu thì đóng lại
        item.addEventListener('focusout', function (event) {
            if (isDesktop() && !item.contains(event.relatedTarget)) {
                setSubmenu(item, false);
            }
        });
    });

    // ----- Drawer -----
    var lastFocused = null;

    function openNav() {
        if (!nav) return;
        lastFocused = document.activeElement;
        nav.classList.add('is-open');
        document.body.classList.add('u-no-scroll');
        if (navToggle) {
            navToggle.setAttribute('aria-expanded', 'true');
            navToggle.setAttribute('aria-label', 'Close menu');
        }
        var focusable = nav.querySelector('[data-nav-close], a, button');
        if (focusable) focusable.focus();
    }

    function closeNav() {
        if (!nav || !nav.classList.contains('is-open')) return;
        nav.classList.remove('is-open');
        document.body.classList.remove('u-no-scroll');
        closeSubmenus();
        if (navToggle) {
            navToggle.setAttribute('aria-expanded', 'false');
            navToggle.setAttribute('aria-label', 'Open menu');
        }
        if (lastFocused && lastFocused.focus) lastFocused.focus();
    }

    if (navToggle) {
        navToggle.addEventListener('click', openNav);
    }

    [].slice.call(document.querySelectorAll('[data-nav-close]')).forEach(function (el) {
        el.addEventListener('click', closeNav);
    });

    // Điều hướng sang trang khác thì đóng drawer
    if (nav) {
        nav.addEventListener('click', function (event) {
            var link = event.target.closest ? event.target.closest('a[href]') : null;
            if (link && link.getAttribute('href').charAt(0) !== '#') {
                closeNav();
            }
        });
    }

    // ----- Click ra ngoài / Esc -----
    document.addEventListener('click', function (event) {
        if (!nav || !nav.contains(event.target)) {
            closeSubmenus();
        }
    });

    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' || event.key === 'Esc') {
            closeSubmenus();
            closeNav();
        }
    });

    // ----- Đổi breakpoint: dọn trạng thái -----
    var resizeTimer;
    window.addEventListener('resize', function () {
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(function () {
            if (isDesktop()) {
                closeNav();
            }
            closeSubmenus();
        }, 150);
    });
})();
